import React, { useEffect } from 'react';

const Lists = (): JSX.Element => {
  useEffect(() => {
    window.location.href = '/lists.html';
  }, []);

  return <div>Redirect to lists.html</div>;
};

export default Lists;
